import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';

const propTypes = {
  deleteRequestPending: PropTypes.bool,
  error: PropTypes.string,
  handleDelete: PropTypes.func,
  isOpen: PropTypes.bool,
  modalData: PropTypes.shape({
    itemType: PropTypes.string,
    itemName: PropTypes.string,
  }),
  toggleModal: PropTypes.func,
};

const defaultProps = {
  deleteRequestPending: false,
  error: '',
  handleDelete: () => {},
  isOpen: false,
  modalData: {},
  toggleModal: () => {},
};

const BasicDeleteConfirmationModal = ({
  deleteRequestPending,
  isOpen,
  toggleModal,
  error,
  handleDelete,
  modalData: { itemType = '', itemName = '' },
}) => {
  return (
    <Modal
      centered
      contentClassName="rounded-lg"
      isOpen={isOpen}
      toggle={() => toggleModal(!isOpen)}
    >
      <ModalHeader toggle={() => toggleModal(!isOpen)}>
        <span className="text-muted">
          {`Delete ${itemType.charAt(0).toUpperCase()}${itemType.substring(
            1
          )}?`}
        </span>
      </ModalHeader>
      <ModalBody className="d-flex flex-column pt-0">
        <p className="mt-3 text-muted three-quarter-text desktop-text">
          The selected {itemType.toLowerCase()}{' '}
          <span className="font-weight-bolder mark">{itemName}</span> will be
          deleted
        </p>
        {error && <span className="text-danger">{error}</span>}
      </ModalBody>
      <ModalFooter className="justify-content-between justify-content-md-end border-top-0">
        <button
          className="btn btn-danger px-3 py-0 nine-tenth-text text-nowrap"
          onClick={handleDelete}
        >
          {deleteRequestPending ? (
            <FontAwesomeIcon
              icon={faCircleNotch}
              spin
              size="lg"
              className="m-1"
            />
          ) : (
            'Yes, Delete'
          )}
        </button>
        <button
          className="btn btn-outline-secondary ml-md-4 px-4 py-0 nine-tenth-text"
          onClick={() => toggleModal(!isOpen)}
        >
          Cancel
        </button>
      </ModalFooter>
      <style jsx>{`
        @media (min-width: 768px) {
          .desktop-text {
            font-size: 1rem !important;
          }
        }
      `}</style>
    </Modal>
  );
};
BasicDeleteConfirmationModal.propTypes = propTypes;
BasicDeleteConfirmationModal.defaultProps = defaultProps;

export default memo(BasicDeleteConfirmationModal);
